import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBtn,_vm._g(_vm._b({attrs:{"type":"button","color":"primary","block":_vm.$vuetify.breakpoint.smAndDown,"disabled":_vm.isDisabled,"depressed":"","small":_vm.isSmall,"exact":_vm.isExact}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }